import { Box, Navbar, ScrollArea, useMantineTheme } from '@mantine/core';
import { FC, ReactNode } from 'react';
import PrimaryNavbar from './PrimaryNavbar';

const DoubleNavbar: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme } = useMantineTheme();

  return (
    <Navbar width={{ sm: 340 }}>
      <ScrollArea scrollbarSize={0} className="non-relative">
        <Navbar.Section grow sx={{ display: 'flex', gap: 5 }}>
          <Box
            sx={{
              boxShadow: colorScheme === 'light' ? '2px 0px 10px #0000001A' : '2px 0 6px rgba(255, 255, 255, 0.05)',
            }}
          >
            <PrimaryNavbar />
          </Box>
          <Box sx={{ flex: 1, minHeight: '100vh' }}>{children}</Box>
        </Navbar.Section>
      </ScrollArea>
    </Navbar>
  );
};

export default DoubleNavbar;
